import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Divider,
  Button,
} from "@mui/material";
import { useLocation, Link } from "react-router-dom";
import DataGrid from "../../components/Datagrid";

const Details = () => {
  const location = useLocation();
  const { row } = location.state || {};
console.log("row0", row)
  if (!row) {
    return <Typography>No data provided.</Typography>;
  }

  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      return new Date(date).toLocaleString();
    } catch {
      return "N/A";
    }
  };

  // ------------------------------
  // Section 1: order.items
  // ------------------------------
  const itemColumns = [
    {
      field: "id",
      headerName: "Item ID",
      flex: 1,
    },
    {
      field: "fulfillment_id",
      headerName: "Fulfillment ID",
      flex: 1,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      valueGetter: ({ row }) => row?.quantity?.count ?? "N/A",
      flex: 1,
    },
  ];

  const itemRows = Array.isArray(row?.order?.items)
    ? row.order.items.map((item, index) => ({
        ...item,
        _id: `item-${index}`,
      }))
    : [];

  // ------------------------------
  // Section 2: quote.breakup with item price + total price columns
  // ------------------------------
  const breakupColumns = [
    {
      field: "item_id",
      headerName: "Item ID",
      flex: 1,
    },
    {
      field: "title",
      headerName: "Title",
      flex: 2,
    },
    {
      field: "title_type",
      headerName: "Title Type",
      flex: 1,
    },
    {
      field: "item_price",
      headerName: "Item Price",
      valueGetter: ({ row }) => `${row?.price?.currency || row?.item?.price?.currency || "INR"} ${
      row?.item?.price?.value || row?.value || "0.00" }`,
      flex: 1,
    },
   
    {
      field: "quantity",
      headerName: "Quantity",
      valueGetter: ({ row }) => row?.count ?? "-",
      flex: 1,
    },
     {
      field: "total_price",
      headerName: "Total Price",
      valueGetter: ({ row }) =>
        `${row?.currency || ""} ${row?.value || "0.00"}`,
      flex: 1,
    },
  ];

  const breakupRows = Array.isArray(row?.order?.quote?.breakup)
    ? row.order.quote.breakup.map((b, index) => ({
        _id: `breakup-${index}`,
        item_id: b?.["@ondc/org/item_id"] ?? "-",
        title: b?.title ?? "-",
        title_type: b?.["@ondc/org/title_type"] ?? "-",
        currency: b?.price?.currency ?? "",
        value: b?.price?.value ?? "0.00",
        count: b?.["@ondc/org/item_quantity"]?.count ?? "-",
        item: b?.item || {}, // to get item.price
      }))
    : [];

  // ------------------------------
  // JSX Return
  // ------------------------------
  return (
    <Card sx={{ maxWidth: "95%", margin: "auto", mt: 4, p: 2 }}>
      <CardContent>
        <Typography variant="h4" gutterBottom>
          Order Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {/* General Info */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography>
              <strong>Order ID:</strong> {row?.ondcOrderId || "N/A"}
            </Typography>
          </Grid>
          
          <Grid item xs={6}>
            <Typography>
              <strong>Created At:</strong>{" "}
              {formatDate(row?.order?.created_at)}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Updated At:</strong>{" "}
              {formatDate(row?.order?.updated_at)}
            </Typography>
          </Grid>
        </Grid>

        {/* Section 1: Items Table */}
        <Divider sx={{ my: 3 }} />
        <Typography variant="h6">Items</Typography>
        <Box sx={{ mt: 2 }}>
          <DataGrid
            col={itemColumns}
            data={itemRows}
            getRowId={(row) => row._id}
            name=""
          />
        </Box>

        {/* Section 2: Breakup Table */}
        <Divider sx={{ my: 3 }} />
        <Typography variant="h6">Quote Breakup</Typography>
        <Box sx={{ mt: 2 }}>
          <DataGrid
            col={breakupColumns}
            data={breakupRows}
            getRowId={(row) => row._id}
            name=""
          />
        </Box>

        {/* Section 3: Price / TTL / Updated */}
        <Divider sx={{ my: 3 }} />
        <Typography variant="h6">Quote Info</Typography>
        <Box sx={{ my: 1, pl: 2, borderLeft: "3px solid #1976d2" }}>
          <Typography>
            <strong>Total Price:</strong> ₹
            {row?.order?.quote?.price?.value || "N/A"}{" "}
            {row?.order?.quote?.price?.currency || ""}
          </Typography>
          <Typography>
            <strong>TTL:</strong> {row?.order?.quote?.ttl || "N/A"}
          </Typography>
          <Typography>
            <strong>Updated At:</strong>{" "}
            {formatDate(row?.order?.updated_at)}
          </Typography>
        </Box>

        {/* Back Button */}
        <Box sx={{ mb: 2, mt: 4 }}>
          <Button
            component={Link}
            to="/app/management/ondc-order"
            variant="outlined"
            color="primary"
          >
            Back
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Details;
